import React from 'react'
import { COLORS } from 'utils'

import { IconStyles } from '../types'
import { EditCustom } from './styles'

interface EditIconProps extends IconStyles {
  onClick?: any
}

export const EditIcon: React.FC<EditIconProps> = ({
  disabled,
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}) => {
  return (
    <EditCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={disabled ? 'default' : cursor}
      onClick={disabled ? () => null : onClick}
      colorIcon={disabled ? COLORS.gray : colorIcon}
    />
  )
}
